import { render, staticRenderFns } from "./IntegerPlusminus.vue?vue&type=template&id=3bf54901&scoped=true&"
import script from "./IntegerPlusminus.vue?vue&type=script&lang=js&"
export * from "./IntegerPlusminus.vue?vue&type=script&lang=js&"
import style0 from "./IntegerPlusminus.vue?vue&type=style&index=0&id=3bf54901&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf54901",
  null
  
)

export default component.exports